import OapStrikethroughScrolling from './code/Scripts/components/OapStrikethroughScrolling.vue';

export default {
  components: {
    OapStrikethroughScrolling,
  },
};
